import React, { Suspense } from 'react'
import AppFallback from './utils/routes/AppFallback'
import { notification } from 'antd'
import ToastProvider from './components/Toast/ToastContext'
import AppRoutes from './utils/routes/AppRoutes'
import { AudioPlayerProvider } from './contexts/AudioPlayerContext'
import { GlobalAudioPlayer } from './components/GlobalAudioPlayer/GlobalAudioPlayer'

function App() {
  const [api, toastContextHolder] = notification.useNotification({
    stack: false,
    maxCount: 4,
  })
  return (
    <Suspense fallback={<AppFallback />}>
      {toastContextHolder}
      <ToastProvider api={api}>
        <AudioPlayerProvider>
          <AppRoutes />
          <GlobalAudioPlayer />
        </AudioPlayerProvider>
      </ToastProvider>
    </Suspense>
  )
}

export default App
